import { Box, Theme, Typography } from "@mui/material";
import {
  PlanTotalPricing,
  CheckedIcon,
  PopularLabel,
  PricingButton,
} from "../components";
import { getHeaderWrapperStyles } from "./styles";
import { PaymentFrequencyEnum } from "@/types/enums.ts";

type AttributeValue = boolean | string | number | JSX.Element;

const getStringValue = (value: AttributeValue): JSX.Element =>
  value as JSX.Element;
const getIconValue = (value: AttributeValue): JSX.Element => (
  <CheckedIcon checked={!!value} />
);

export const getValueForAttribute = (
  features: IPlanFeatureValue[],
  featureMasterID: number,
): JSX.Element | null => {
  const chosenFeature = features.find(
    (item) => item.featureMasterID === featureMasterID
  )?.productFeatureValue;

  if (chosenFeature) {
    if (chosenFeature.toLowerCase() != 'true' && chosenFeature.toLowerCase() != 'false') {
      return getStringValue(chosenFeature);
    }

    if (chosenFeature.toLowerCase() == 'true') {
      return getIconValue(true);
    }
  }

  return getIconValue(false);
};

export const ROWS = {
  name: "name",
  description: "description",
  totalPrice: "totalPrice",
  button: "button",
  monthlyPrice: "monthlyPrice",
};

export const pricingRows = [
  ROWS.name,
  ROWS.description,
  ROWS.totalPrice,
  ROWS.button,
  ROWS.monthlyPrice,
];

export const getPricingComponentByName = (
  plan: IPlan,
  name: string,
  theme: Theme,
  paymentFrequency: PaymentFrequencyEnum,
) => {
  switch (name) {
    case ROWS.name:
      return (
        <Box
          position="relative"
          mt={3}
          sx={getHeaderWrapperStyles(theme, plan.mostPopular)}
          style={{ minWidth: '205px' }}
        >
          <Typography variant="h4" component="h3" fontSize={24}>
            {plan.name}
          </Typography>
          {plan.mostPopular && <PopularLabel />}
        </Box>
      );
    case ROWS.description:
      return (
        <Typography variant="body1" color="text.secondary">
          Advanced capabilities
        </Typography>
      );
    case ROWS.totalPrice:
      switch (paymentFrequency) {
        case PaymentFrequencyEnum.YEARLY:
          return (
              <Box>
                <PlanTotalPricing
                    annuallyPrice={plan.yearlyPrice}
                    priceInfo={`Pay $${(12 * plan.yearlyPrice) % 1 === 0 ? 12 * plan.yearlyPrice : (12 * plan.yearlyPrice).toFixed(2)} annually`}
                />
              </Box>
          );
        case PaymentFrequencyEnum.QUARTERLY:
          return (
              <Box>
                <PlanTotalPricing
                    annuallyPrice={plan.monthlyPrice}
                    priceInfo={`Pay $${(3 * plan.monthlyPrice) % 1 === 0 ? 3 * plan.monthlyPrice : (3 * plan.monthlyPrice).toFixed(2)} quarterly`}
                />
              </Box>
          );
        default:
          return (
              <Box>
                <PlanTotalPricing annuallyPrice={plan.monthlyPrice} priceInfo = {`Pay $${1 * plan.monthlyPrice} monthly`} />
              </Box>
          );
      }
    case ROWS.button:
      return <PricingButton plan={plan} />;
    default:
      return null;
  }
};
